import v100 from 'src/components/forms/schemas/eventResult/patientSafetyScreener/1.0.0';

export default {
  latest: v100,
  '1.0.0': v100,
};
